
import React from 'react';
import { FacilityOrderNewFlowMissingInventoryCountConfirmModalTemplate } from 'themes/application/facility-order-new-flow-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowMissingInventoryCountConfirmModalStore } from 'application/facility-order-new-flow-inventory/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowMissingInventoryCountConfirmModalStore(rootStore, componentProps), 'facilityOrderNewFlowMissingInventoryCountConfirmModalStore')
@observer
class FacilityOrderNewFlowMissingInventoryCountConfirmModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowMissingInventoryCountConfirmModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowMissingInventoryCountConfirmModal;
